"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.novaScotiaCities = void 0;
exports.novaScotiaCities = [
    {
        label: "Amherst",
        value: 410,
    },
    {
        label: "Annapolis Royal",
        value: 412,
    },
    {
        label: "Antigonish",
        value: 414,
    },
    {
        label: "Arcadia",
        value: 409,
    },
    {
        label: "Armdale",
        value: 411,
    },
    {
        label: "Aylesford",
        value: 413,
    },
    {
        label: "Baddeck",
        value: 415,
    },
    {
        label: "Bakers Settlement",
        value: 405,
    },
    {
        label: "Barrington Pas.",
        value: 416,
    },
    {
        label: "Beach Meadows",
        value: 404,
    },
    {
        label: "Bear River",
        value: 417,
    },
    {
        label: "Beaver Bank",
        value: 403,
    },
    {
        label: "Bedford, NS",
        value: 452,
    },
    {
        label: "Beechville",
        value: 561,
    },
    {
        label: "Belmont, NS",
        value: 402,
    },
    {
        label: "Berwick",
        value: 418,
    },
    {
        label: "Bible Hill",
        value: 419,
    },
    {
        label: "Black Point",
        value: 591,
    },
    {
        label: "Blandford",
        value: 420,
    },
    {
        label: "Blockhouse",
        value: 421,
    },
    {
        label: "Bonico",
        value: 590,
    },
    {
        label: "Bridgetown",
        value: 422,
    },
    {
        label: "Bridgewater",
        value: 424,
    },
    {
        label: "Brier Island",
        value: 423,
    },
    {
        label: "Brockfield",
        value: 425,
    },
    {
        label: "Brookfield",
        value: 426,
    },
    {
        label: "Brookside",
        value: 401,
    },
    {
        label: "Caledonia, NS",
        value: 427,
    },
    {
        label: "Camperdown",
        value: 400,
    },
    {
        label: "Canning",
        value: 428,
    },
    {
        label: "Canso",
        value: 430,
    },
    {
        label: "Cape Breton",
        value: 429,
    },
    {
        label: "Centerville, NS",
        value: 431,
    },
    {
        label: "Centreville",
        value: 398,
    },
    {
        label: "Chester",
        value: 433,
    },
    {
        label: "Chester Basin",
        value: 434,
    },
    {
        label: "Cheticamp",
        value: 435,
    },
    {
        label: "Church Point",
        value: 436,
    },
    {
        label: "Clark's Harbour",
        value: 432,
    },
    {
        label: "Clementsvale",
        value: 437,
    },
    {
        label: "Cleveland",
        value: 471,
    },
    {
        label: "Colchester",
        value: 438,
    },
    {
        label: "Coldbrook",
        value: 564,
    },
    {
        label: "Cole Harbour",
        value: 511,
    },
    {
        label: "Cow Bay",
        value: 387,
    },
    {
        label: "Cumberland, NS",
        value: 439,
    },
    {
        label: "Dalhousie, NS",
        value: 441,
    },
    {
        label: "Dartmouth",
        value: 440,
    },
    {
        label: "Debert, NS",
        value: 550,
    },
    {
        label: "Deep Brook",
        value: 566,
    },
    {
        label: "Digby",
        value: 442,
    },
    {
        label: "Dingwall",
        value: 592,
    },
    {
        label: "Dominion",
        value: 446,
    },
    {
        label: "East Bay",
        value: 443,
    },
    {
        label: "East Lake Ainslie",
        value: 396,
    },
    {
        label: "East Pennant",
        value: 567,
    },
    {
        label: "Eastern Passage",
        value: 478,
    },
    {
        label: "Economy",
        value: 479,
    },
    {
        label: "Ellerhouse",
        value: 444,
    },
    {
        label: "Elmsdale",
        value: 569,
    },
    {
        label: "Enfield",
        value: 559,
    },
    {
        label: "Englishtown",
        value: 395,
    },
    {
        label: "Eskasoni",
        value: 445,
    },
    {
        label: "Fall River",
        value: 447,
    },
    {
        label: "Falmouth, NS",
        value: 551,
    },
    {
        label: "Fletchers",
        value: 394,
    },
    {
        label: "Freeport",
        value: 448,
    },
    {
        label: "Gaetz Brook",
        value: 582,
    },
    {
        label: "Gillis Point",
        value: 593,
    },
    {
        label: "Glace Bay",
        value: 532,
    },
    {
        label: "Glenwood, NS",
        value: 449,
    },
    {
        label: "Grand Pre",
        value: 451,
    },
    {
        label: "Grand River",
        value: 487,
    },
    {
        label: "Granville",
        value: 454,
    },
    {
        label: "Granville Ferry",
        value: 453,
    },
    {
        label: "Greenwood, NS",
        value: 455,
    },
    {
        label: "Guysborough",
        value: 457,
    },
    {
        label: "Halifax",
        value: 450,
    },
    {
        label: "Hammands Plains",
        value: 573,
    },
    {
        label: "Hants County",
        value: 489,
    },
    {
        label: "Hantsport",
        value: 460,
    },
    {
        label: "Hatchet Lake",
        value: 407,
    },
    {
        label: "Head Chezzetcook",
        value: 563,
    },
    {
        label: "Head Of Jeddore",
        value: 575,
    },
    {
        label: "Herring Cove",
        value: 576,
    },
    {
        label: "Hillsburn",
        value: 393,
    },
    {
        label: "Hubbards, NS",
        value: 458,
    },
    {
        label: "Hubley",
        value: 577,
    },
    {
        label: "Indian Brook",
        value: 367,
    },
    {
        label: "Ingonish Beach",
        value: 462,
    },
    {
        label: "Inverness, NS",
        value: 459,
    },
    {
        label: "Irish Cove",
        value: 461,
    },
    {
        label: "Jeddore Oyster Ponds",
        value: 377,
    },
    {
        label: "Judique",
        value: 392,
    },
    {
        label: "Karsdale",
        value: 391,
    },
    {
        label: "Kempt",
        value: 389,
    },
    {
        label: "Kentville, NS",
        value: 464,
    },
    {
        label: "Kings City",
        value: 463,
    },
    {
        label: "Kingston, NS",
        value: 465,
    },
    {
        label: "Kingsville, NS",
        value: 466,
    },
    {
        label: "La Have",
        value: 467,
    },
    {
        label: "Lake Echo",
        value: 397,
    },
    {
        label: "Lakeside",
        value: 383,
    },
    {
        label: "Lantz",
        value: 468,
    },
    {
        label: "Larry's River",
        value: 523,
    },
    {
        label: "Lawrencetown",
        value: 469,
    },
    {
        label: "Litchfield",
        value: 384,
    },
    {
        label: "Liverpool",
        value: 470,
    },
    {
        label: "Lockeport",
        value: 472,
    },
    {
        label: "Louisbourg",
        value: 474,
    },
    {
        label: "Lower L'Ardoise",
        value: 473,
    },
    {
        label: "Lower Sackville",
        value: 475,
    },
    {
        label: "Lucasville",
        value: 406,
    },
    {
        label: "Lunenburg",
        value: 476,
    },
    {
        label: "Lunnenburg County",
        value: 477,
    },
    {
        label: "Mabou",
        value: 531,
    },
    {
        label: "Mahone Bay",
        value: 480,
    },
    {
        label: "Malagash",
        value: 578,
    },
    {
        label: "Margaree Forks",
        value: 533,
    },
    {
        label: "Margaretsville",
        value: 579,
    },
    {
        label: "Marion Bridge",
        value: 529,
    },
    {
        label: "Martins River",
        value: 481,
    },
    {
        label: "Mavillette",
        value: 385,
    },
    {
        label: "Merigomish, NS",
        value: 553,
    },
    {
        label: "Meteghan River",
        value: 483,
    },
    {
        label: "Middle Sackville",
        value: 379,
    },
    {
        label: "Middleton",
        value: 482,
    },
    {
        label: "Mill Village",
        value: 537,
    },
    {
        label: "Millbrook, NS",
        value: 366,
    },
    {
        label: "Minesville",
        value: 485,
    },
    {
        label: "Moose River",
        value: 557,
    },
    {
        label: "Mulgrave",
        value: 484,
    },
    {
        label: "Musquodoboit",
        value: 486,
    },
    {
        label: "New Germany",
        value: 488,
    },
    {
        label: "New Glasgow, NS",
        value: 490,
    },
    {
        label: "New Minas",
        value: 491,
    },
    {
        label: "New Waterford",
        value: 492,
    },
    {
        label: "Newport",
        value: 380,
    },
    {
        label: "Noel",
        value: 493,
    },
    {
        label: "North East Point",
        value: 381,
    },
    {
        label: "North Sydney",
        value: 496,
    },
    {
        label: "Northwest Cove",
        value: 494,
    },
    {
        label: "Oakfield",
        value: 565,
    },
    {
        label: "Other",
        value: 599,
    },
    {
        label: "Oxford, NS",
        value: 502,
    },
    {
        label: "Parrsboro",
        value: 510,
    },
    {
        label: "Petit-de-Grat",
        value: 497,
    },
    {
        label: "Petite Riviere",
        value: 495,
    },
    {
        label: "Pictou",
        value: 512,
    },
    {
        label: "Pleasant Bay",
        value: 498,
    },
    {
        label: "Pleasant Valley",
        value: 499,
    },
    {
        label: "Pleasantville",
        value: 595,
    },
    {
        label: "Pomquet",
        value: 500,
    },
    {
        label: "Port George",
        value: 504,
    },
    {
        label: "Port Hawkesbury",
        value: 514,
    },
    {
        label: "Port Hood",
        value: 503,
    },
    {
        label: "Port Maitland",
        value: 501,
    },
    {
        label: "Port Saxon",
        value: 539,
    },
    {
        label: "Port Williams",
        value: 505,
    },
    {
        label: "Porters Lake",
        value: 506,
    },
    {
        label: "Potter's Lake",
        value: 596,
    },
    {
        label: "Poulamon",
        value: 507,
    },
    {
        label: "Prospect",
        value: 597,
    },
    {
        label: "Pugwash",
        value: 508,
    },
    {
        label: "River Denys",
        value: 594,
    },
    {
        label: "River John",
        value: 541,
    },
    {
        label: "Roberta",
        value: 375,
    },
    {
        label: "Rose Bay",
        value: 509,
    },
    {
        label: "Sackville, NS",
        value: 456,
    },
    {
        label: "Salmon River",
        value: 543,
    },
    {
        label: "Sandford",
        value: 513,
    },
    {
        label: "Saulnierville",
        value: 545,
    },
    {
        label: "Scotch Village",
        value: 555,
    },
    {
        label: "Scotsburn",
        value: 589,
    },
    {
        label: "Seabright",
        value: 583,
    },
    {
        label: "Shad Bay",
        value: 369,
    },
    {
        label: "Shag Harbour",
        value: 515,
    },
    {
        label: "Shear Water",
        value: 516,
    },
    {
        label: "Sheet Harbour",
        value: 517,
    },
    {
        label: "Shelburne, NS",
        value: 518,
    },
    {
        label: "Sherbrooke, NS",
        value: 547,
    },
    {
        label: "Shubenacadie",
        value: 519,
    },
    {
        label: "Shubewacad",
        value: 521,
    },
    {
        label: "South Ohio",
        value: 584,
    },
    {
        label: "Springfield",
        value: 585,
    },
    {
        label: "Springhill",
        value: 520,
    },
    {
        label: "St Margaret's Bay",
        value: 525,
    },
    {
        label: "St. George's Channel",
        value: 526,
    },
    {
        label: "St. Peter's",
        value: 527,
    },
    {
        label: "Ste. Anne du Ruis",
        value: 528,
    },
    {
        label: "Stellarton",
        value: 522,
    },
    {
        label: "Stewiacke",
        value: 524,
    },
    {
        label: "Stillwater Lake",
        value: 586,
    },
    {
        label: "Sydney Mines",
        value: 534,
    },
    {
        label: "Sydney, NS",
        value: 530,
    },
    {
        label: "Tantallon, NS",
        value: 536,
    },
    {
        label: "Tatamagouche",
        value: 538,
    },
    {
        label: "Terence Bay",
        value: 598,
    },
    {
        label: "Timberlea",
        value: 535,
    },
    {
        label: "Trenton, NS",
        value: 540,
    },
    {
        label: "Truro",
        value: 542,
    },
    {
        label: "Tusket",
        value: 544,
    },
    {
        label: "Upper Kennetcook",
        value: 548,
    },
    {
        label: "Upper Stewiacke",
        value: 546,
    },
    {
        label: "Upper Tantallon",
        value: 370,
    },
    {
        label: "Walton, NS",
        value: 552,
    },
    {
        label: "Waterville, NS",
        value: 554,
    },
    {
        label: "Waverley",
        value: 556,
    },
    {
        label: "Wedge Port",
        value: 558,
    },
    {
        label: "Wellington, NS",
        value: 549,
    },
    {
        label: "West Arichat",
        value: 587,
    },
    {
        label: "West Bay",
        value: 560,
    },
    {
        label: "West Dover",
        value: 562,
    },
    {
        label: "Westville",
        value: 570,
    },
    {
        label: "Weymouth",
        value: 568,
    },
    {
        label: "Whites Lake",
        value: 588,
    },
    {
        label: "Whycocomagh",
        value: 408,
    },
    {
        label: "Wilmot, NS",
        value: 571,
    },
    {
        label: "Windsor, NS",
        value: 572,
    },
    {
        label: "Wolfville",
        value: 574,
    },
    {
        label: "Woods Harbour",
        value: 371,
    },
    {
        label: "Yarmouth",
        value: 580,
    },
];
